module.exports = __webpack_public_path__ + "img/icon-edit.dc27b6bf.svg";